import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Offer } from 'prismic';
import { ProductListItem } from 'product-shared';

@Component({
  selector: 'lib-offer-box-image',
  templateUrl: './offer-box-image.component.html',
  styleUrls: ['./offer-box-image.component.scss'],
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferBoxImageComponent {
  @Input() offer: Offer<ProductListItem>;
  @Input() size: 'small' | 'medium' = 'medium';
  @Input() boxHasBanner: boolean;
  @Input() lazyLoadImage = true;
}
